module.exports = __webpack_public_path__ + "static/docs/Vermietungsplaene_Tuefwis_Keller_Haus_C_200114.4092bf91.pdf";